import { render, staticRenderFns } from "./PrintFooter.vue?vue&type=template&id=130e172a&scoped=true"
import script from "./PrintFooter.vue?vue&type=script&lang=js"
export * from "./PrintFooter.vue?vue&type=script&lang=js"
import style0 from "./PrintFooter.vue?vue&type=style&index=0&id=130e172a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130e172a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('130e172a')) {
      api.createRecord('130e172a', component.options)
    } else {
      api.reload('130e172a', component.options)
    }
    module.hot.accept("./PrintFooter.vue?vue&type=template&id=130e172a&scoped=true", function () {
      api.rerender('130e172a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/print/PrintFooter.vue"
export default component.exports